module.exports = __webpack_public_path__ + "static/media/feature-mobile-profile.d6b2800b.png";